export default "__VITE_ASSET__Bhe2FQqS__"